// extracted by mini-css-extract-plugin
export default {"Onl":"OLN_Onl__hvjvz","Logo":"OLN_Logo__38mFP"};